import Dimmer from "@/components/UI/Dimmer/Dimmer";
import styles from './Modal.module.scss'
import {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import ReactDOM from "react-dom";
import Icon from "@/components/UI/Icon/Icon";

type Props = {
  open?: boolean
  children: React.ReactNode
  onClose?: () => void
  footer?: React.ReactNode
  size?: 'small' | 'medium' | 'large'
  header?: React.ReactNode
  closeIcon?: boolean
  className?: string
  contentClassName?: string
  blur?: boolean
}

const Modal = ({open, children, onClose, footer, size, closeIcon, header, className, contentClassName, blur}: Props) => {
  const [visible, setVisible] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const bodyRef = useRef<HTMLBodyElement>()
  const nextDivRef = useRef<HTMLDivElement>()


  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        event.preventDefault()
        onClose && onClose()
      }
    }
    bodyRef.current = document.querySelector('body') as HTMLBodyElement
    nextDivRef.current = document.getElementById('__next') as HTMLDivElement
    if (open) {
      setIsOpen(true)
      bodyRef.current.style.overflow = 'hidden'
      if (blur) {
        nextDivRef.current.style.filter = 'blur(5px)'
        nextDivRef.current.style.contain = 'paint'
      }
      setTimeout(() => setVisible(true), 50)
      bodyRef.current.addEventListener('keydown', handleKeyDown)
    }
    else if(isOpen) {
      setVisible(false)
      bodyRef.current.style.overflow = 'auto'
      nextDivRef.current.style.filter = 'none'
      setTimeout(() => setIsOpen(false), 250)
      setTimeout(() => {
        nextDivRef.current!.style.contain = 'none' // Weird shifting on android if this isn't delayed
      }, 500)
      bodyRef.current.removeEventListener('keydown', handleKeyDown)
    }
    return () => {
      bodyRef.current!.style.overflow = 'auto'
      bodyRef.current!.removeEventListener('keydown', handleKeyDown)
    }
  }, [open]);

  return (
    <>
      {isOpen && ReactDOM.createPortal(
        <div id="ch-page-modal" className={classNames(styles.outerModalContainer, visible && styles.visible)}>
          <Dimmer className={styles.dimmer} dark onClick={() => onClose && onClose()} />
          <div className={classNames(styles.modal, visible && styles.inPosition, size && styles[size], className)}>
            {closeIcon && (
              <div className={styles.closeIcon} onClick={() => onClose && onClose()}>
                <Icon icon="close" />
              </div>
            )}
            {header && (
              <div className={styles.header}>
                <h4>{header}</h4>
              </div>
            )}
            <div className={classNames(styles.content, contentClassName)}>{children}</div>
            {footer && (
              <div className={styles.footer}>
                {footer}
              </div>
            )}
          </div>
        </div>, bodyRef.current as HTMLBodyElement)
      }
    </>
  )
}

export default Modal
